import { paginationType } from "global/Interfaces/Interfaces"
import TooltipWrapper from "global/tooltip/TooltipWrapper"
import { useState } from "react"
import { BiImageAdd } from "react-icons/bi"
import { CiCircleInfo } from "react-icons/ci"
import { FiCreditCard } from "react-icons/fi"
import { MdHistory, MdOutlineReceiptLong } from "react-icons/md"
import { useDispatch, useSelector } from "react-redux"
import { filterCreditSettlement } from "redux/settlement-credit"
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb"
import SwitchOptionTable from "../../components/OptionsTable/SwitchOptionTable"
import NewStaticTable from "../../components/staticTable/NewStaticTable"
import { getDay, getPrice } from "../../tools/functions/Methods"
import { CreditColumns } from "./CreditColumns"
import DeliverySearchForm from "./CreditSearch"
import BankDelivery from "./bank-delivery"
import ConsumerCredit from "./consumer-credit-details"
import PaymentDetailCredit from "./credit-payment-details"
import SinglePayment from "./single-payment"
import { usePayment } from "./single-payment/usepayment"
import { sync } from "./utils"
import UserPayment from "./user-payment"
import { hasPermission } from "utils/HasPermission"

const CreditSettlement = () => {
  const dispatch = useDispatch()
  const { handleSubmit, refId } = usePayment()
  const { filter, settlementData, fetchPost } = useSelector(
    (state: any) => state.creditSettlement
  )
  const { pageNumbers } = useSelector((state: paginationType) => state.paginate)
  const [selectedRow, setSelectedRow] = useState<any>([])

  const [currentData, setCurrentData] = useState()
  const [openModal, setOpenModal] = useState({
    consumerCredit: false,
    deposit: false,
    bankDelivery: false,
    paymentDetail: false,
    userPayment: false,
  })

  let data =
    settlementData?.payload?.content?.length !== 0
      ? settlementData?.payload?.content?.map((item: any) => {
          return {
            ...item,

            creditAmount: getPrice(item.creditAmount),
            hubName: item.creditRecipientHub?.name,
            settlementMonth:
              !!item.creditValidTo &&
              item.creditValidTo.year + "/" + item.creditValidTo.month,
            creditValidTo: !!item.creditValidTo && getDay(item.creditValidTo),
            settlementDate:
              !!item.settlementDate && getDay(item.settlementDate),
            creditBalance: getPrice(item.creditBalance),
            // remainCredit: getPrice(item.creditAmount - item.usedCredit),
            receiveCredit: item.creditorHub?.name,
            totalPayment: getPrice(item.totalPayment),
            insurance: getPrice(item.insurance),
            settledAmount:getPrice(item.settledAmount),
            totalPayable: getPrice(item.totalPayable),
            hubShareAmount:getPrice(item?.hubShareAmount),
            settlementStatus:
              item.settlementStatus === 1 ? "پرداخت شده" : "در انتظار پرداخت",
            usedCredit: item.usedCredit,
            tableusedCredit: getPrice(item.usedCredit),
            operation: (
              <div className='flex w-full gap-3 justify-center'>
                {hasPermission("refresh_credit") && (
                  <button
                    className=' border-none	 text-[14px]  w-[20px] h-[20px]   '
                    onClick={() => sync(item, refreshTable)}
                  >
                    <TooltipWrapper textProps='رفرش سقف اعتبار'>
                      <MdHistory size={20} />
                    </TooltipWrapper>
                  </button>
                )}
                <button
                  className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                  onClick={() => {}}
                >
                  <TooltipWrapper textProps='افزودن تکی فیش بانکی'>
                    <BiImageAdd size={20} />
                  </TooltipWrapper>
                </button>

                <button
                  className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                  onClick={() => {
                    setCurrentData(item)

                    setOpenModal({ ...openModal, consumerCredit: true })
                  }}
                >
                  <TooltipWrapper textProps='جزئیات اعتبار مصرفی'>
                    <CiCircleInfo size={20} />
                  </TooltipWrapper>
                </button>
                <button
                  className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                  onClick={() => {
                    setCurrentData(item)
                    setOpenModal({ ...openModal, paymentDetail: true })
                  }}
                >
                  <TooltipWrapper textProps='جزئیات پرداخت ها'>
                    <MdOutlineReceiptLong size={20} />
                  </TooltipWrapper>
                </button>
                <button
                  className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                  onClick={() => {
                    setCurrentData(item)
                    setOpenModal({ ...openModal, userPayment: true })
                    // handleSubmit(item);
                  }}
                >
                  <TooltipWrapper textProps={"واریز وجه"}>
                    <FiCreditCard size={20} />
                  </TooltipWrapper>
                </button>
              </div>
            ),
          }
        })
      : []

  const refreshTable = () => {
    dispatch(
      filterCreditSettlement({
        ...filter,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    )
  }
  // const convertConsumeSelectedRow = (values) => {
  //   return values.map((value) => ({
  //     date: value.creditValidTo,
  //     hub: value?.hub?.name || "هاب تهزلن",
  //     id: value.id,
  //     price: value.usedCredit,
  //   }));
  // };
  console.log("data is ", data)
  return (
    <>
      <Breadcrumb curentPage='تسویه اعتبار' beforePage='اعتبار' />
      {/* <span>هاب: </span>{" "}
      <span className=" font-semibold">{userInfo?.currenthub?.label}</span> */}
      <DeliverySearchForm />
      <SwitchOptionTable
        accessPage={[
          {
            code: "A63",
            value: () => setOpenModal({ ...openModal, deposit: true }),
            // permission: hasPermission("groupDeliveryoutofPlan"),
          },
          {
            code: "A64",
            value: () => setOpenModal({ ...openModal, bankDelivery: true }),
            // permission: hasPermission("groupDeliveryoutofPlan"),
          },
          // {
          //   code: "A65",
          //   value: () => setOpenModal({ ...openModal, consumerCredit: true }),
          // },
          {
            code: "A1",
            value: {
              data: data,
              columns: CreditColumns,
              title: "groupPayment",
            },
          },
        ]}
        // selectedState={selectedRow}
      />
      <NewStaticTable
        data={data ? data : []}
        THWrapper={"whitespace-nowrap"}
        // selectAble={true}
        pagination={settlementData?.payload?.totalElements}
        setselectedState={(value) => setSelectedRow(value)}
        selectedState={selectedRow}
        column={CreditColumns}
        loading={fetchPost}
        ignoreRedux={true}
      />
      {openModal.consumerCredit && (
        <ConsumerCredit
          open={openModal.consumerCredit}
          setOpen={setOpenModal}
          currentData={currentData}
        />
      )}
      <SinglePayment refId={refId} />
      {/* <Deposit
        open={openModal.deposit}
        setOpen={setOpenModal}
        selectedRows={convertSelectedRow(selectedRow)}
      /> */}
      {openModal.paymentDetail && (
        <PaymentDetailCredit
          open={openModal.paymentDetail}
          setOpen={setOpenModal}
          currentData={currentData}
        />
      )}
      <BankDelivery open={openModal.bankDelivery} setOpen={setOpenModal} />
      {openModal.userPayment && (
        <UserPayment
          open={openModal.userPayment}
          setOpen={setOpenModal}
          submit={(item) => handleSubmit(item)}
          currentData={currentData}
        />
      )}
    </>
  )
}

export default CreditSettlement
